export { default } from './modules/JavascriptTimeAgo';
export { intlDateTimeFormatSupported, intlDateTimeFormatSupportedLocale } from './modules/locale';
export { default as RelativeTimeFormat } from './modules/RelativeTimeFormat';